var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Aguardando Pagamento")]),_c('p',[_vm._v(" Estamos aguardando a confirmação do seu pagamento pela instituição financeira. Enquanto isso, confira alguns artigos importantes em nosso blog. ")])])
}]

export { render, staticRenderFns }